/*! @azure/msal-common v15.12.0 2025-08-19 */
'use strict';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const cacheQuotaExceeded = "cache_quota_exceeded";
const cacheErrorUnknown = "cache_error_unknown";
export { cacheErrorUnknown, cacheQuotaExceeded };
